import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import AccountGroupsContainer from './AccountGroupsContainer';
import AccountGroupContainer from './AccountGroupContainer';
import UsersContainer from './UsersContainer';
import CompaniesContainer from './CompaniesContainer';
import CompanyContainer from './CompanyContainer';
import ChatsStatsContainer from './ChatsStatsContainer';
import ChatStatsContainer from './ChatStatsContainer';
import LoaderContainer from './LoaderContainer';
import ResultsContainer from './ResultsContainer';
import ResultContainer from './ResultContainer';
import OpportunityBuilderContainer from './OpportunityBuilderContainer';
import OpportunitiesContainer from './OpportunitiesContainer';
import TeamsContainer from './TeamsContainer';
import TeamContainer from './TeamContainer';
import Sidebar from '../../components/Sidebar';
import PromptTesterContainer from './PromptTesterContainer';
import EchoPulseResultChatPromptContainer from './EchoPulseResultChatPromptContainer';
import EchoPulseFullTesterContainer from './EchoPulseFullTesterContainer';
import SmsTestContainer from './SmsTestContainer';

const ContentContainer = () => {
  return (
    <div className="App-main">
      <Sidebar />
      <div className="App-content">
        <Switch>
          <Route path="/ai/prompts/echo-pulse-result-chat" component={EchoPulseResultChatPromptContainer} />
          <Route path="/ai/prompts/tester/echo-pulse-full" component={EchoPulseFullTesterContainer} />
          <Route path="/ai/prompts/tester" component={PromptTesterContainer} />
          <Route path="/tools/sms-test" component={SmsTestContainer} />
          <Route path="/settings/opportunities/new" component={OpportunityBuilderContainer} />
          <Route path="/settings/opportunities/:postId" component={OpportunityBuilderContainer} />
          <Route path="/settings/opportunities" component={OpportunitiesContainer} />
          <Route path="/settings/teams/new" component={TeamContainer} />
          <Route path="/settings/teams/:teamId" component={TeamContainer} />
          <Route path="/settings/teams" component={TeamsContainer} />
          <Route path="/settings/companies/new" component={CompanyContainer} />
          <Route path="/settings/companies/:companyId" component={CompanyContainer} />
          <Route path="/settings/companies" component={CompaniesContainer} />
          <Route path="/settings/accounts/groups/new" component={AccountGroupContainer} />
          <Route path="/settings/accounts/groups/:groupId" component={AccountGroupContainer} />
          <Route path="/settings/accounts/groups" component={AccountGroupsContainer} />
          <Route path="/settings/users" component={UsersContainer} />
          <Route path="/data/chats/stats/:projectId" component={ChatStatsContainer} />
          <Route path="/data/chats/stats" component={ChatsStatsContainer} />
          <Route path="/data/results/:projectId/:id/:gameId" component={ResultContainer} />
          <Route path="/data/results" component={ResultsContainer} />
          <Route strict path="/" render={() => <Redirect to="/settings/companies" />} />
        </Switch>
        <LoaderContainer />
      </div>
    </div>
  );
};

export default ContentContainer;



// WEBPACK FOOTER //
// ./src/containers/private/ContentContainer.js